<template>
  <div class="disney-terms">
    <div class="multi-lang">
      <u>{{ $t("Disney+ Terms and Conditions") }}</u>
    </div>
    <p v-if="loadFailed" class="terms-fallback">
      <a :href="termsUrl">{{ $t("Disney+ Terms and Conditions") }}</a>
    </p>
    <div v-else class="terms-content" v-html="dataset"></div>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";

export default {
  data() {
    return {
      dataset: "",
      loadFailed: false,
      localDisplayLangCode: localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en",
      requestId: 0,
    };
  },
  computed: {
    termsUrl() {
      const language = ["en", "eng"].includes(this.localDisplayLangCode) ? "en-es" : "es-ar";
      return `https://d3k6mli483yb9r.cloudfront.net/static/mvshub/${language}/disneyplustermsofuse.html`;
    },
  },
  watch: {
    "$i18n.locale"(locale) {
      this.updateLanguage(locale);
    },
  },
  methods: {
    updateLanguage(language) {
      this.localDisplayLangCode = language || localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en";
      this.fetchTermsContent();
    },
    onLanguageViewChange() {
      this.updateLanguage();
    },
    async fetchTermsContent() {
      const requestId = ++this.requestId;
      this.dataset = "";
      this.loadFailed = false;
      try {
        const response = await fetch(this.termsUrl);
        if (!response.ok) {
          throw new Error(`Unable to load Disney+ terms: ${response.status}`);
        }
        const content = await response.text();
        if (requestId === this.requestId) this.dataset = content;
      } catch (error) {
        if (requestId === this.requestId) this.loadFailed = true;
      }
    },
  },
  created() {
    eventBus.$on("check-local-storage", this.updateLanguage);
    eventBus.$on("changeLanguageView", this.onLanguageViewChange);
  },
  mounted() {
    window.scrollTo(0, 0);
    this.fetchTermsContent();
  },
  beforeDestroy() {
    this.requestId++;
    eventBus.$off("check-local-storage", this.updateLanguage);
    eventBus.$off("changeLanguageView", this.onLanguageViewChange);
  },
};
</script>

<style scoped lang="scss">
.disney-terms {
  min-width: 0;
  overflow-wrap: anywhere;
}
.terms-content {
  max-width: 100%;
  overflow-x: auto;
}
.multi-lang {
  text-align: center;
  color: #777;
  font-size: 24px;
  font-weight: bold;
  margin-top: 4rem;
  padding: 0 1rem;
}
.terms-fallback {
  text-align: center;
  padding: 1rem;
  a {
    color: inherit;
  }
}
</style>
